import ViewChoicesTab from "./sub_tabs/ViewChoicesTab";


const choicesTabRouter = {

  list: 
  {
    title: 'List',
    element: <ViewChoicesTab />
  }

}

export default choicesTabRouter;